(() => {
'use strict';
if (customElements.get('okan-approved-earcuff-picker')) return;
const memory = new Map();
const esc = value => String(value ?? '').replace(/[&<>"']/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
const norm = value => String(value).normalize('NFD').replace(/[\u0300-\u036f]/g,'').toLowerCase();
const icons = {
 diamond:'<svg viewBox="0 0 24 24" aria-hidden="true"><path d="m3 8 4-5h10l4 5-9 13L3 8Z M3 8h18 M7 3l5 18 5-18 M7 3l5 5 5-5"/></svg>',
 heart:'<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M20.8 4.6a5.5 5.5 0 0 0-7.8 0L12 5.7l-1.1-1.1a5.5 5.5 0 0 0-7.8 7.8L12 21l8.8-8.6a5.5 5.5 0 0 0 0-7.8Z"/></svg>',
 chat:'<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M21 11.5a9 9 0 0 1-13.2 8L3 21l1.5-4.8A9 9 0 1 1 21 11.5Z"/></svg>',
 chevron:'<svg class="okr-chevron" viewBox="0 0 12 12" aria-hidden="true"><path d="m4 2 4 4-4 4"/></svg>'
};
customElements.define('okan-approved-earcuff-picker', class extends HTMLElement {
 connectedCallback() {
  if (this.ui) return;
  this.scope = this.closest('.shopify-section');
  if (!this.scope) return;
  this.en = this.dataset.lang.startsWith('en');
  this.key = this.dataset.sectionId + ':' + this.dataset.productId;
  this.state = memory.get(this.key) || {open:{metal:false,style:false}};
  memory.set(this.key,this.state);
  this.variants = JSON.parse(this.querySelector('[data-approved-variants]').textContent);
  this.names = JSON.parse(this.querySelector('[data-approved-options]').textContent);
  this.positions = {};
  this.names.forEach((name,i) => {
   const n=norm(name);
   if (/pierre|stone|gem/.test(n)) this.positions.stone=i+1;
   else if (/taille|size/.test(n)) this.positions.size=i+1;
   else if (/couleur|color|colour|matiere|material|metal/.test(n)) this.positions.metal=i+1;
  });
  this.positions.metal=Number(this.dataset.metalPosition);
  delete this.positions.size;
  if(Number(this.dataset.stylePosition)>0)this.positions.style=Number(this.dataset.stylePosition);
  this.names.forEach((name,i)=>{
   const values=[...new Set(this.variants.map(v=>v.options[i]))];
   if(/chaine|chain/.test(norm(name)) || (values.length>1 && values.every(v=>/chaine|chain/.test(norm(v))))) this.positions.chain=i+1;
  });
  this.abort = new AbortController();
  this.observer = new MutationObserver(() => this.schedule());
  this.scope.addEventListener('change',()=>this.schedule(),{signal:this.abort.signal});
  this.sync();
 }
 t(fr,en) {return this.en?en:fr;}
 url(path) {return (this.dataset.root || '/').replace(/\/$/,'')+'/'+path;}
 picker() {return [...this.scope.querySelectorAll('variant-picker')].find(p=>p.dataset.productId===this.dataset.productId&&!p.closest('product-card,quick-add-dialog'));}
 inputs(kind) {const pos=this.positions[kind]; return pos?[...(this.picker()?.querySelectorAll(`input[type="radio"][data-input-id^="${pos}-"]`)||[])]:[];}
 schedule() {if(this.queued)return;this.queued=true;queueMicrotask(()=>{this.queued=false;if(this.isConnected)this.sync();});}
 sync() {
  this.observer.disconnect();
  try {
   const picker=this.picker();
   if(!picker || !this.inputs('metal').length || (this.positions.style&&!this.inputs('style').length)) {picker?.removeAttribute('data-okan-loading');return;}
   if(!this.ui?.isConnected) this.build(picker);
   picker.classList.add('okr-native-picker');
   for(const kind of Object.keys(this.positions)) for(const input of this.inputs(kind)) input.closest('fieldset')?.classList.add('okr-native-field');
   for(const source of picker.querySelectorAll('[data-okan-color-price]')) source.classList.add('okr-native-field');
   for(const kind of ['metal','stone','chain','style']) this.syncGroup(kind);
   const values=this.names.map((_,i)=>picker.querySelector(`input[data-input-id^="${i+1}-"]:checked`)?.value);
   this.current=this.variants.find(v=>v.options.every((value,i)=>value===values[i]));
   const nativePrice=picker.querySelector('[data-okan-color-price] .okan-selected-color-price__amount');
   const price=this.ui.querySelector('.okr-price');
   const html=this.current?.formatted || nativePrice?.innerHTML || '';
   if(price.innerHTML!==html)price.innerHTML=html;
   this.moveAlma();
   this.setAttribute('data-ready','');
   picker.removeAttribute('data-okan-loading');
  } finally {
   if(this.isConnected)this.observer.observe(this.scope,{childList:true,subtree:true,characterData:true,attributes:true,attributeFilter:['checked','disabled','data-option-available']});
  }
 }
 build(picker) {
  this.ui=document.createElement('div');this.ui.className='okr-picker okr-earcuff-picker';
  this.ui.innerHTML='<div class="okr-price-row"><div class="okr-price" aria-live="polite"></div><div class="okr-alma-slot"></div></div>';
  this.groups={};
  for(const kind of ['metal','stone','chain','style']) {
   if(!this.positions[kind])continue;
   const section=document.createElement('section');section.className='okr-group';
   const title=kind==='metal'?(this.dataset.metalHeading||this.t('CHOISIS TON MÉTAL','CHOOSE YOUR METAL')):kind==='stone'?this.t('CHOISIS TA PIERRE','CHOOSE YOUR STONE'):kind==='chain'?this.t('CHOISIS TA CHAÎNE','CHOOSE YOUR CHAIN'):(this.dataset.styleHeading||this.t('CHOISIS TON PORTÉ','HOW WILL YOU WEAR IT?'));
   const id='okr-'+kind+'-'+this.key.replace(/[^a-z0-9_-]/gi,'-');
   section.innerHTML=`<button type="button" class="okr-toggle" aria-expanded="${!!this.state.open[kind]}" aria-controls="${id}"><span class="okr-title">${title}</span><span class="okr-summary"></span>${kind==='metal'?'<span class="okr-dot okr-header-dot" aria-hidden="true"></span>':kind==='stone'?'<span class="okr-header-stone" aria-hidden="true"></span>':kind==='style'?'<span class="okr-header-ear" aria-hidden="true"></span>':''}${icons.chevron}</button><div class="okr-panel" id="${id}"><div class="okr-panel-inner">${kind==='metal'?'<p class="okr-description"></p>':''}<div class="okr-options" role="group" aria-label="${title}"></div><div class="okr-links"></div></div></div>`;
   if(kind==='style'){const ear=this.querySelector('[data-ear]')?.content.firstElementChild.cloneNode(true);if(ear)section.querySelector('.okr-header-ear').append(ear);}
   const panel=section.querySelector('.okr-panel');panel.hidden=!this.state.open[kind];panel.inert=!this.state.open[kind];
   section.querySelector('.okr-toggle').onclick=()=>this.setOpen(kind,!this.state.open[kind]);
   this.ui.append(section);this.groups[kind]=section;
  }
  picker.before(this.ui);
  this.ui.dataset.productId=this.dataset.productId;
 }
 stoneVisual(value) {
  const source=this.querySelector('[data-stone-visuals]')?.content;
  return [...(source?.querySelectorAll('label')||[])].find(label=>label.querySelector('input')?.value===value)?.querySelector('.okan-ring-stones__visual');
 }
 syncGroup(kind) {
  const section=this.groups[kind];if(!section)return;
  const inputs=this.inputs(kind);const checked=inputs.find(i=>i.checked);
  section.querySelector('.okr-summary').textContent=checked?.value||this.t('Sélectionner','Select');
  if(kind==='stone') {
   const holder=section.querySelector('.okr-header-stone');
   const source=this.stoneVisual(checked?.value)?.querySelector('img');
   holder.replaceChildren();holder.hidden=!source;
   if(source){
    const img=source.cloneNode(true);img.removeAttribute('id');img.alt='';img.loading='eager';holder.append(img);
    const badge=source.closest('.okan-ring-stones__visual')?.querySelector('.okan-stone-arc-v2');
    if(badge){
     const label=document.createElement('span');label.className='okr-header-novelty';
     label.textContent=(badge.querySelector('textPath')?.textContent||this.t('NOUVEAU','NEW')).trim();
     const separator=document.createElement('span');separator.className='okr-novelty-separator';separator.textContent=' · ';separator.setAttribute('aria-hidden','true');
     section.querySelector('.okr-summary').prepend(label,separator);
    }
   }
  }
  if(kind==='metal') {
   const silver=/argent|silver/i.test(checked?.value||'');
   section.querySelector('.okr-header-dot').classList.toggle('is-silver',silver);
   section.querySelector('.okr-header-dot').classList.toggle('is-bicolor',/bicolore|two[ -]?tone/i.test(checked?.value||''));
   section.querySelector('.okr-description').textContent=/bicolore|two[ -]?tone/i.test(checked?.value||'')?this.t('Un cœur argent massif recouvert d’or jaune 18 carats et de rhodium pour protéger de l’oxydation.','A solid silver core coated with 18-carat yellow gold and rhodium to protect against oxidation.'):silver?(this.dataset.silverBody||this.t('De l’argent massif 925, protégé par une fine couche de rhodium pour préserver son éclat.','Solid 925 sterling silver, protected by a fine layer of rhodium to preserve its shine.')):(this.dataset.goldBody||this.t('Un cœur en laiton recouvert d’or 18 carats','A brass core plated with 18-carat gold'));
  }
  const options=section.querySelector('.okr-options');
  const signature=JSON.stringify(inputs.map(i=>[i.value,i.checked,i.disabled,i.dataset.optionAvailable]));
  if(options.dataset.signature===signature)return;
  options.dataset.signature=signature;
  const focused=options.contains(document.activeElement)?document.activeElement.dataset.value:null;
  options.replaceChildren();options.className='okr-options okr-options-'+kind;
  inputs.forEach(input=>{
   const button=document.createElement('button');button.type='button';button.dataset.value=input.value;button.className='okr-option';
   button.setAttribute('aria-pressed',String(input.checked));button.disabled=input.disabled;
   button.classList.toggle('is-unavailable',input.dataset.optionAvailable==='false');
   if(input.dataset.optionAvailable==='false')button.setAttribute('aria-label',input.value+' — '+this.t('indisponible','unavailable'));
   if(kind==='metal')button.innerHTML=`<span class="okr-dot ${/bicolore|two[ -]?tone/i.test(input.value)?'is-bicolor':/argent|silver/i.test(input.value)?'is-silver':''}" aria-hidden="true"></span><span>${esc(input.value)}</span>`;
   else if(kind==='stone') {
    const visual=this.stoneVisual(input.value)?.cloneNode(true);
    if(visual){visual.querySelectorAll('[id]').forEach(el=>{const old=el.id;el.id=old+'-approved';visual.querySelectorAll('[href]').forEach(ref=>{if(ref.getAttribute('href')==='#'+old)ref.setAttribute('href','#'+el.id);});});button.append(visual);}
    const label=document.createElement('span');label.textContent=input.value;button.append(label);
   } else {button.textContent=input.value;if(kind==='style'){const ear=this.querySelector('[data-ear]')?.content.firstElementChild.cloneNode(true);if(ear)button.prepend(ear);}}
   button.onclick=()=>this.select(kind,input.value,true);
   button.onpointerenter=event=>{
    if(event.pointerType!=='mouse'||!matchMedia('(hover: hover)').matches||input.checked||input.dataset.optionAvailable==='false')return;
    clearTimeout(this.hoverTimer);this.hoverTimer=setTimeout(()=>this.select(kind,input.value,false),100);
   };
   button.onpointerleave=()=>clearTimeout(this.hoverTimer);
   options.append(button);
  });
  if(focused) [...options.children].find(b=>b.dataset.value===focused)?.focus({preventScroll:true});
  const links=section.querySelector('.okr-links');links.replaceChildren();
  if(kind==='metal')links.innerHTML=`<a href="${(this.dataset.materialUrl||this.url('pages/nos-metaux-precieux'))}" target="_blank" rel="noopener">${icons.diamond}<span>${this.t('Tout savoir sur nos métaux','Discover our metals')}</span></a><a href="${this.url('pages/notre-engagement-ethique')}" target="_blank" rel="noopener">${icons.heart}<span>${this.t('Découvrir notre engagement RJC','Discover our RJC commitment')}</span></a>`;

 }
 select(kind,value,close) {
  clearTimeout(this.hoverTimer);
  const input=this.inputs(kind).find(i=>i.value===value);if(!input||input.disabled)return;
  if(close)this.setOpen(kind,false);
  if(!input.checked) input.click();
  this.schedule();
  if(close)this.groups[kind]?.querySelector('.okr-toggle').focus({preventScroll:true});
 }
 setOpen(kind,open) {
  if(open) Object.keys(this.groups).forEach(other=>{if(other!==kind&&this.state.open[other])this.setOpen(other,false);});
  const section=this.groups[kind];if(!section||this.state.open[kind]===open)return;
  const panel=section.querySelector('.okr-panel');const start=panel.hidden?0:panel.getBoundingClientRect().height;
  panel._animation?.cancel();this.state.open[kind]=open;
  section.querySelector('.okr-toggle').setAttribute('aria-expanded',String(open));
  panel.hidden=false;panel.inert=!open;
  const end=open?panel.scrollHeight:0;
  if(matchMedia('(prefers-reduced-motion: reduce)').matches){panel.hidden=!open;return;}
  panel._animation=panel.animate([{height:start+'px'},{height:end+'px'}],{duration:600,easing:'cubic-bezier(.4,0,.2,1)'});
  panel._animation.onfinish=()=>{panel.hidden=!this.state.open[kind];panel._animation=null;};
 }
 moveAlma() {
  const widget=this.scope.querySelector('#alma-widget');if(!widget||this.ui.contains(widget))return;
  const block=widget.closest('.shopify-app-block')||widget;
  if(block.contains(this.ui))return;
  this.almaAnchor?.remove();this.almaAnchor=document.createComment('Alma original location');block.before(this.almaAnchor);this.almaBlock=block;
  this.ui.querySelector('.okr-alma-slot').append(block);
 }
 disconnectedCallback(){
  this.observer?.disconnect();this.abort?.abort();clearTimeout(this.hoverTimer);this.dialog?.remove();
  if(this.almaAnchor?.isConnected&&this.almaBlock)this.almaAnchor.replaceWith(this.almaBlock);
  this.ui?.remove();this.ui=null;
  this.scope?.querySelectorAll('.okr-native-field').forEach(e=>e.classList.remove('okr-native-field'));
  this.picker()?.classList.remove('okr-native-picker');
 }
});
})();
